import type { ReactNode } from "react";
import "./sheet.css";

/*
  The One Sheet world's root: the `.sheet` token scope. Every public page (the
  landing, About, FAQ, the auth flows, not found, the route error) renders
  inside it, so each looks the same whatever theme a signed-in user picked;
  `/y` never does. Everything is cut from this one sheet of paper; the figures
  and the thread draw themselves, so the root carries no engine.
*/
export function SheetWorld({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={className ? `sheet ${className}` : "sheet"}>{children}</div>;
}
